"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPhoneNumberUpdateDto = instanceOfPhoneNumberUpdateDto;
exports.PhoneNumberUpdateDtoFromJSON = PhoneNumberUpdateDtoFromJSON;
exports.PhoneNumberUpdateDtoFromJSONTyped = PhoneNumberUpdateDtoFromJSONTyped;
exports.PhoneNumberUpdateDtoToJSON = PhoneNumberUpdateDtoToJSON;
exports.PhoneNumberUpdateDtoToJSONTyped = PhoneNumberUpdateDtoToJSONTyped;
/**
 * Check if a given object implements the PhoneNumberUpdateDto interface.
 */
function instanceOfPhoneNumberUpdateDto(value) {
    return true;
}
function PhoneNumberUpdateDtoFromJSON(json) {
    return PhoneNumberUpdateDtoFromJSONTyped(json, false);
}
function PhoneNumberUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'number': json['number'] == null ? undefined : json['number'],
        'receiveSms': json['receiveSms'] == null ? undefined : json['receiveSms'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function PhoneNumberUpdateDtoToJSON(json) {
    return PhoneNumberUpdateDtoToJSONTyped(json, false);
}
function PhoneNumberUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'number': value['number'],
        'receiveSms': value['receiveSms'],
        'type': value['type'],
    };
}
//# sourceMappingURL=PhoneNumberUpdateDto.js.map